module.exports = __webpack_public_path__ + "img/mc.70dae1cc.png";